import { Component, OnInit } from '@angular/core';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit{

  constructor(private utilService: UtilitieService){}

  ngOnInit(): void {
    this.utilService.updateLoading(false);
  }

}
